import { useState } from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  LinearProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { Add as AddIcon } from "@material-ui/icons";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import { DialogCreateRelease } from "components/Dialogs/DialogCreateRelease";
import PeriodField from "components/_refactor/fields/period-field";
import HeaderClientes from "components/_refactor/headers/clients";
import LoadingData from "components/Loading/LoadingData";
import useLogs from "hooks/logs";
import Api from "lib/api/httpRequestHelper";
import { TableReleases } from "./table/TableReleases";
import { Typography } from "@material-ui/core";

import componentStyles from "assets/theme/components/cards/sortable/card-light-table-sortable";
import { IsMobile, IsMobile900 } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useCustomStyles = makeStyles({
  fields: {
    display: "flex",
    flexDirection: "column",
    width: 300,
    marginTop: "1rem",
  },
  option: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    wordBreak: "keep-all",
  },
  paper: {
    width: "max-content !important",
    minWidth: "100%",
  },
  popper: {
    maxWidth: "calc(100% - 60px - 1.5rem)",
    width: "max-content",
  },
});

function GerenciamentoReleaseNotes() {
  const snackbar = useSnackbar();
  const classes = { ...useStyles(), ...useCustomStyles() };
  const { setLocalStorageActions, setLocalStorageApiProblem } = useLogs();

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const [periodo, setPeriodo] = useState(null);
  const [dataInicial, setDataInicial] = useState(null);
  const [dataFinal, setDataFinal] = useState();
  const [searching, setSearching] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [releases, setReleases] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);
  const [selectedRow, setSelectedRow] = useState(null);
  const [typeView, setTypeView] = useState(null);
  const [isDeletingRelease, setIsDeletingRelease] = useState(false);

  const handleSearchReleases = async ({ page = 1, sizePerPage = 25 }) => {
    setSearching(true);
    setCancelLoading(false);
    setLocalStorageActions({
      nomeTela: "Release Notes",
      idMenu: "161",
      acao: "Acessou a tela Release Notes",
    });

    await Api.get(
      "release-product-list",
      "conteudo",
      `?page=${page - 1}` +
        `&pageSize=${sizePerPage ? sizePerPage : 25}` +
        `&dtIni=${dataInicial}&dtFim=${dataFinal}`,
      true
    )
      .then(({ Success, Result }) => {
        if (Success) {
          setReleases(Result?.Releases || []);
          setTotalRegisters(Result?.TotalRegistro);
          setCurrentPage(page);
          setCurrentSizePerPage(sizePerPage);
        }
      })
      .catch((error) => {
        setLocalStorageApiProblem({
          idMenuAccess: "161",
          screen: "Release Notes",
          problem: `Erro na chamada do endpoint release-product-list - ${error}`,
        });
        if (localStorage.getItem("loggedIn")) {
          snackbar.showMessage(error, {
            severity: "error",
          });
        }
      })
      .finally(() => setSearching(false));
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setSearching(false);
    setReleases([]);
  };

  const handleDeleteRelease = async () => {
    try {
      setIsDeletingRelease(true);
      await Api.delete(
        "delete-release-product",
        "conteudo",
        {
          idReleaseSistemaProduto: selectedRow.IdReleaseSistemaProduto,
        },
        true
      );
      snackbar.showMessage("Release Note excluida com sucesso.", {
        severity: "success",
      });
      setTypeView(null);
      setSelectedRow(null);
      handleSearchReleases({ page: 1 });
    } catch {
      snackbar.showMessage("Erro ao excluir Release Note.", {
        severity: "error",
      });
    } finally {
      setIsDeletingRelease(false);
    }
  };

  return (
    <>
      <HeaderClientes section="Release Notes" subsection="Gerenciamento" />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardHeader
                className={classes.cardHeader}
                title="Filtros"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sm={periodo?.value === "Outros" ? 12 : 6}
                    md={periodo?.value === "Outros" ? 12 : 3}
                  >
                    <PeriodField
                      label="Período"
                      value={periodo}
                      onChange={setPeriodo}
                      initialDate={dataInicial}
                      finalDate={dataFinal}
                      setInitialDate={setDataInicial}
                      setFinalDate={setDataFinal}
                      disabled={searching}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      style={
                        isMobile || isMobile900
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      variant="contained"
                      onClick={handleSearchReleases}
                      disabled={searching}
                    >
                      {searching ? "Pesquisando..." : "Pesquisar"}
                    </Button>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Button
                      style={
                        isMobile || isMobile900
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      variant="contained"
                      onClick={() => setOpenDialog(true)}
                      disabled={searching}
                    >
                      <Box component={AddIcon} top="-2px" /> Criar Release
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <LoadingData
              searching={searching}
              onClick={() => handleStopSearching()}
              classes={classes.root}
              label="Buscando dados..."
            />
          </Grid>
          {!searching && releases !== null && !cancelLoading ? (
            <TableReleases
              setSelectedRow={setSelectedRow}
              dataTable={releases}
              totalRegistros={totalRegisters}
              currentPage={currentPage}
              currentSizePerPage={currentSizePerPage}
              search={handleSearchReleases}
              setTypeView={setTypeView}
            />
          ) : null}
          {(openDialog || (selectedRow && typeView !== "delete")) && (
            <DialogCreateRelease
              open={selectedRow ? selectedRow : openDialog}
              typeView={typeView}
              selectedRow={selectedRow}
              onClose={(hasUpdated) => {
                setTypeView(null);
                setSelectedRow(null);
                setOpenDialog(false);
                if (hasUpdated) {
                  handleSearchReleases({
                    page: 1,
                    sizePerPage: 25,
                  });
                }
              }}
            />
          )}
          <Dialog
            open={typeView === "delete"}
            onClose={() => {
              setReleases((releases) =>
                releases.filter((item) => item.id !== selectedRow.id)
              );
              setTypeView(null);
              setSelectedRow(null);
            }}
            aria-labelledby="alert-dialog-title"
          >
            <DialogTitle>
              <span>
                <Typography id="alert-dialog-title" variant="h3" component="h3">
                  Excluir Release Note
                </Typography>
              </span>
            </DialogTitle>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleDeleteRelease();
              }}
            >
              <DialogContent style={{ padding: "1rem 1.5rem 1.5rem" }}>
                <Typography id="alert-dialog-description" variant="h4">
                  Confirmar exclusão da release note?
                </Typography>

                {isDeletingRelease ? (
                  <div
                    style={{
                      marginTop: "2rem",
                    }}
                  >
                    <span>Deletando release note</span>
                    <LinearProgress />
                  </div>
                ) : null}
                <DialogActions>
                  {!isDeletingRelease ? (
                    <>
                      <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => {
                          setTypeView(null);
                          setSelectedRow(null);
                        }}
                      >
                        Cancelar
                      </Button>
                      <Button color="default" variant="contained" type="submit">
                        Confirmar
                      </Button>
                    </>
                  ) : null}
                </DialogActions>
              </DialogContent>
            </form>
          </Dialog>
        </Grid>
      </Container>
    </>
  );
}

export { GerenciamentoReleaseNotes };
